$(function () {
    "use strict";

    $(document).on('change', '.tag-filter_js', function(eventObject) {
        var link = $(eventObject.target).val();

        if (link) {
            document.location = link;
        }
    });
});